

$( document ).ready(function() {
  
  $( ".header__link-list.secondary_menu" ).insertAfter( ".shopify-section--header" );
  $('.slideshow__slide img').css('min-height',$('.media-grid__item x-slideshow').height());
  $(window).resize(function(){
    $('.slideshow__slide img').css('min-height',$('.media-grid__item x-slideshow').height());
  });

  $(".popover-listbox__option").on('click', function() {
    var optId = $('input[name="id"]').val();
    $('.lb-item--sale').hide();
    $('.lb-pre-sale-'+optId).show();
    
  });
  
  $(".popup-shiping, .zip-learn-more").on('click', function() {
    $('body').addClass('model-active');
    $(".custom-model-main").addClass('model-open');
  }); 
  $(".close-btn, .bg-overlay").click(function(){
    $('body').removeClass('model-active');
    $(".custom-model-main").removeClass('model-open');
  });
  
  $('.nav-tabs-sticky').stickyTabs();

  var tabLinks = document.querySelectorAll(".tablinks");
  var tabContent =document.querySelectorAll(".tabcontent");

  tabLinks.forEach(function(el) {
    el.addEventListener("click", openTabs);
  });


  function openTabs(el) {
    var btn = el.currentTarget; // lắng nghe sự kiện và hiển thị các element
    var electronic = btn.dataset.electronic; // lấy giá trị trong data-electronic

    tabContent.forEach(function(el) {
      el.classList.remove("active");
    });

    tabLinks.forEach(function(el) {
      el.classList.remove("active");
    });

    document.querySelector("#" + electronic).classList.add("active");

    btn.classList.add("active");
  }
  var params = new window.URLSearchParams(window.location.search);
  var paramTab = params.get('goto');
  if(paramTab == 'shipping'){
    $("#link2").trigger('click');
  }
  if(paramTab == 'returns'){
    $("#link3").trigger('click');
  }
  if(paramTab == 'warranty'){
    $("#link4").trigger('click');
  }

  $('.toddler_box').click(function(){
    $(this).toggleClass("active");
  });
  
});
$(window).on('load', function() {
  $("body").addClass("page-loaded");
  $('.header-search .search-input input').attr('placeholder','Search thousands of products…');
  $( "#menuList>li" ).hover(
    function() {
      
      var curE = $(this);
		setTimeout(function(){
			var isHovered = curE.is(":hover");
          
			if(isHovered || curE.children('.menu-level-1').is(":hover")){
              $( '#menuList>li:first-child' ).removeClass('active');
              $( '#menuList>li:first-child .menu-level-1>li:first-child' ).removeClass('active');
              curE.addClass('active');
              $( '#menuList>li.active .menu-level-1>li:first-child' ).addClass('active');
			}else{
				
			}

		}, 150);
    }, function() {
      
      var curE = $(this);
		setTimeout(function(){
			var isHovered = curE.is(":hover");
			if(isHovered || curE.children('.menu-level-1').is(":hover")){
              
			}else{
				$( '#menuList>li.active .menu-level-1>li:first-child' ).removeClass('active');
                curE.removeClass('active');
                $( '#menuList>li:first-child' ).addClass('active');
                $( '#menuList>li:first-child .menu-level-1>li:first-child' ).addClass('active');
			}

		}, 150);
    }
  );
 
  $( ".menu-level-1>li" ).hover(
    function() {
      
      var curE = $(this);
		setTimeout(function(){
			var isHovered = curE.is(":hover");
			if(isHovered || curE.children('ul').is(":hover")){
              $( '#menuList>li.active .menu-level-1>li:first-child' ).removeClass('active');
              curE.addClass('active');
			}else{
				
			}

		}, 150);
    }, function() {
      var curE = $(this);
		setTimeout(function(){
			var isHovered = curE.is(":hover");
			if(isHovered || curE.children('ul').is(":hover")){
              
			}else{
				curE.removeClass('active');
                $( '#menuList>li.active .menu-level-1>li:first-child' ).addClass('active');
			}

		}, 150);
      
    }
  );
  
  $('.btn-menu').click(function(){
      if($(this).hasClass('active')){
        $( '#menuList>li:first-child' ).removeClass('active');
        $( '#menuList>li:first-child .menu-level-1>li:first-child' ).removeClass('active');
        $(this).removeClass('active');
        $('.main-navigation-container').removeClass('active');
      }else{
        $( '#menuList>li:first-child' ).addClass('active');
        $( '#menuList>li:first-child .menu-level-1>li:first-child' ).addClass('active');
        $(this).addClass('active');
        $('.main-navigation-container').addClass('active');
      }
    });


  $('.overlay').click(function(){
    $('.btn-menu').removeClass('active');
    $('.main-navigation-container').removeClass('active');
    
  });
  $('.product-info .shopify-app-block').click(function(){
    $('html, body').animate({
                    scrollTop: $("#review").offset().top
                }, 600);
    
  });

  $('.more-less').click(function() {
    $('.more-text').toggleClass('open');
    if ($('.more-less:contains("Read More...")').length > 0) {
        $('.more-less').text('Show Less');
    } else if ($('.more-less:contains("Show Less")').length > 0){
        $('.more-less').text('Read More...');
    }
  });

  $(window).on('scroll', function() {
    var scrollTop = $(this).scrollTop();
      $('#gallery, #description, #specifications, #review').each(function() {
          var topDistance = $(this).offset().top;
          var headerHeight = $('store-header').height() + $('.nav-tabs-sticky').height();
          if ( (topDistance - headerHeight) < scrollTop ) {
              $('.nav-tabs-sticky li').removeClass('active');
              var activeClass = ".tab-" + $(this).attr('id');
              $(activeClass).parent().addClass('active');
          }
      });
  });

  $('.tab-pane .title').click(function(){
      if($(this).parents('.tab-pane').hasClass('active')){
        $(this).parents('.tab-pane').removeClass('active');
      }else{
        $(this).parents('.tab-pane').addClass('active');
      }
    });
  
  if($(window).width() < 821){
    $('.footer__block--menu p, .footer__block--text p ').click(function(){
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $(this).parent().addClass('active');
      }
    });
    
  }
  setTimeout(function(){
      isUrlExists($(".product-info__vendor .brand img").attr('src'), function(status){
          if(status === 404){
             $('.product-info__vendor').addClass('not-found-img');
            $('.product-info .shopify-block.shopify-app-block').addClass('no-brand');
          }
      });
    }, 1000);
});

function isUrlExists(url, cb){
    jQuery.ajax({
        url:      url,
        dataType: 'text',
        type:     'GET',
        complete:  function(xhr){
            if(typeof cb === 'function')
               cb.apply(this, [xhr.status]);
        }
    });
}
